export default __webpack_public_path__ + "static/media/321613989115-5.41306ed6.jpg";